import * as actions from "./actions";
import { rootRef } from "../../config/firebase";
// import moment from "moment";

/*- operations -*/
function obtenerListadoBajas() {
  // const fechaInicio = moment()
  //   .subtract(1, "month")
  //   .format("YYYYMMDD");

  return dispatch =>
    rootRef
      .child("extraescolares/bajas")
      .orderByChild("fechaBaja")
      .once("value", snap =>
        dispatch(actions.obtenerListadoBajas(Object.values(snap.val())))
      );
}

function resetListadoBajas() {
  return actions.resetListadoBajas();
}

/*---*/
export { obtenerListadoBajas, resetListadoBajas };



// WEBPACK FOOTER //
// ./src/ducks/listados/operations.js